<template>
    <pm-custom-dialog v-if="visible" v-model="visible" style="z-index: 999999999999;">

        <div style="padding: 0 0px; text-align: center;">

            <div v-show="!altTextVisible">
                <div style="background: url(/images/onboarding/scales.jpg) center center / contain no-repeat rgb(255, 255, 255); margin: 20px 0px 0px 0; width: 100%; height: 170px;"></div>
                <div style="margin-bottom: 16px; margin-top: 20px; margin-bottom: 30px; text-align: center;">
                    <h2 style="line-height: 1.2; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">
                        Costs as a cup of coffee.<br/>
                        <span style="font-weight: 800">Worth much more.</span>
                    </h2>
                </div>




                <div style="display: flex; justify-content: center; padding: 0 30px;">



                    <div style="display: flex; flex-direction: column; ">
                        <div style="display: flex; flex-grow: 0; align-items: center; text-align: center;">
                            <mdi style="color: green; margin-bottom: 6px;">mdiCheck</mdi>
                            <div style="flex-grow: 0; font-weight: 600; line-height: 1.3; padding-left: 12px; padding-bottom: 6px; margin-bottom: 6px;">
                                Hours of time saved
                            </div>
                        </div>

                        <div style="display: flex; flex-grow: 0; align-items: center; text-align: left;">
                            <mdi style="color: green; margin-bottom: 6px;">mdiCheck</mdi>
                            <div style="flex-grow: 0; font-weight: 600; line-height: 1.3; padding-left: 12px; padding-bottom: 6px; margin-bottom: 6px;">
                                Qualified patients
                            </div>
                        </div>

                        <div style="display: flex; flex-grow: 0; align-items: center; text-align: left;">
                            <mdi style="color: green; margin-bottom: 6px;">mdiCheck</mdi>
                            <div style="flex-grow: 0; font-weight: 600; line-height: 1.3; padding-left: 12px; padding-bottom: 6px; margin-bottom: 6px;">
                                Better case acceptance
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                <div style="padding: 0 10px; max-width: 320px; margin: 0 auto;">
                    Join the dental professionals who are already <b>enjoying these benefits</b>!
                </div>

                <!-- <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 50ms" @click="retry">
                    I WANT <span style="text-transform: none; font-weight: 600;">&nbsp;DentiCalc&nbsp;</span> PREMIUM
                </a> -->

                <pm-iap-product-button x-override-class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 50ms; margin: 16px auto 0 auto;" referrer="click_iap_coffee_retry" text="Unlock DentiCalc" />

                <!-- <br/>
                <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 100ms" @click="showAltText">
                    I'D RATHER BUY A COFFEE :)
                </a>
                <br/>
                <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 150ms" @click="report">
                    I NEED SUPPORT
                </a> -->
                <br/>
                <a class="close-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 200ms" @click="close">
                    <v-icon style="color: #2962ff; font-size:16px; margin-right: 6px;">close</v-icon> LATER
                </a>
            </div>

            <div v-show="altTextVisible">

                <div style="background: url(/images/onboarding/dreamstime_xxl_76825094s.jpg) center center / contain no-repeat rgb(255, 255, 255); margin: 0px 0px 0px 0; width: 100%; height: 270px;"></div>

                <div style="margin-bottom: 16px; margin-top: 20px; text-align: center;">
                    <h2 style="line-height: 1.2; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">
                        You can have both...
                    </h2>
                </div>

                <p style="line-height: 1.3; font-size: 15px; margin-bottom: 8px; padding: 0 30px;">
                    ...with DentiCalc you will have more free time to enjoy your favourite coffee too.
                </p>
                <br/>

                <!-- <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 50ms" @click="retry">
                    I WANT <span style="text-transform: none; font-weight: 600;">&nbsp;DentiCalc&nbsp;</span> PREMIUM
                </a> -->

                <pm-iap-product-button override-class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 50ms;" referrer="click_iap_coffee_retry_alt" text="I WANT DentiCalc PREMIUM" />

                <br/>

                <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 100ms" @click="report">
                    I NEED SUPPORT
                </a>
                <br/>

                <a class="close-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 100ms" @click="close">
                    <v-icon style="color: #2962ff; font-size:16px; margin-right: 6px;">close</v-icon> CLOSE
                </a>
            </div>
        </div>
    </pm-custom-dialog>
</template>

<script>
import PmCustomDialog from "./base-dialog.vue";
// import coffeeSvg from "@/components/svg/coffee.vue";
import PmIapProductButton from "@/components/core/iap-product-button.vue";

export default {
    components: {
        PmCustomDialog,
        // coffeeSvg,
        PmIapProductButton,
    },
    data: () => ({
        visible: false,
        altTextVisible: false,
    }),
    methods: {
        show() {
            this.visible = true;
            this.altTextVisible = false;
        },
        showAltText() {
            window.Tracker.logEvent({
                event_name: "buy_coffee",
                event_category: "iap",
                event_label: "cancel_dialog_price",
            });
            this.altTextVisible = true;
        },
        close() {
            window.Tracker.logEvent({
                event_name: this.altTextVisible ? "close_alt" : "close",
                event_category: "iap",
                event_label: "cancel_dialog_price",
            });
            this.visible = false;
            this.$emit('close');
        },
        retry() {
            app.$bus.$emit('openAppDialog','premium',{'title': '', 'referrer': 'click_retry_worth_it'});
            IAP.autoRetryPurchase = true;
            window.Tracker.logEvent({
                event_name: this.altTextVisible ? "retry_alt" : "retry",
                event_category: "iap",
                event_label: "cancel_dialog_price",
            });
        },
        report() {
            app.$bus.$emit('openAppDialog','storeSupport');
            window.Tracker.logEvent({
                event_name: this.altTextVisible ? "support_alt" : "support",
                event_category: "iap",
                event_label: "cancel_dialog_price",
            });
        },
    }
}
</script>
